import { Component, OnInit, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { BackButtonService } from 'src/app/shared/services/back-url.service';

@Component({
    selector: 'app-back-button',
    templateUrl: './back-button.component.html',
    styleUrls: ['./back-button.component.scss']
})
export class BackButtonComponent implements OnInit {
    @HostListener('click')

    onClick() {
        this.backUrlService.goBack();
    }

    constructor(public backUrlService: BackButtonService, private router: Router) {
        backUrlService.setPreviousUrl();
    }

    ngOnInit(): void { }
}
